import React, { useState } from 'react'
import clsx from 'clsx'
import { ListMessages } from './ListMessages'
import { Control } from './Control'
import { useSelector } from 'react-redux'
export const DirectMessagingFrontend = (props) => {
  var [isOpen, setOpen] = useState(false);
  const DMStore = useSelector((state) => state.DirectMessaging);
  console.log(DMStore)
  return (
    <>
      <div className="direct-messaging-icon" onClick={() => setOpen(true)}>
        <i className="fas fa-comments fa-2xx"></i>
        <div className="badge">
          {DMStore.user_chat_count > 0 && DMStore.user_chat_count}
        </div>
      </div>
      <div className={clsx({
        'direct-messaging': true,
        'active': isOpen
      })}>
        <Control />
        <ListMessages onClose={() => setOpen(false)} item={props.room} isOpen={isOpen} />
      </div>
    </>
  );
};
